// extracted by mini-css-extract-plugin
export default {"imgdiv":"cafd27b1ff _5bcf0865e3","img":"ade7d65b33 _64979cfaf4"};